import { useIntl } from 'react-intl'
import TagTitle from './TagTitle'
import { DropdownFromOptions as Dropdown } from 'components/controls'
import { useMonths, useIntlMemo } from 'hooks/intl'

export function TagsDropdown({ values = [], value, onChange }) {
    const intl = useIntl()
    const options = new Map(values.map(value => [value, <TagTitle key={value} value={value} />]))
    const placeholder = intl.formatMessage({
        defaultMessage: 'All tags',
    })

    return <Dropdown value={value} onChange={onChange} options={options} placeholder={placeholder} />
}

// Constants
export function useYearOptions() {
    const currentYear = new Date().getFullYear()

    return useIntlMemo(
        intl =>
            new Map([
                [undefined, intl.formatMessage({ defaultMessage: 'All years' })],
                ...Array(currentYear - 2012) // We are are going back to 2013!
                    .fill(currentYear)
                    .map((value, index) => value - index)
                    .map(year => [year, String(year)]),
            ])
    )
}

export function useMonthsOptions() {
    const month = useMonths()

    return useIntlMemo(
        intl =>
            new Map([
                [
                    undefined,
                    intl.formatMessage({
                        defaultMessage: 'All months',
                        description: 'Layout feed/Feed',
                    }),
                ],
                ['january', month[0]],
                ['february', month[1]],
                ['march', month[2]],
                ['april', month[3]],
                ['may', month[4]],
                ['june', month[5]],
                ['july', month[6]],
                ['august', month[7]],
                ['september', month[8]],
                ['october', month[9]],
                ['november', month[10]],
                ['december', month[11]],
            ])
    )
}

export function useTimelineOptions() {
    return useIntlMemo(
        intl =>
            new Map([
                [
                    false,
                    intl.formatMessage({
                        defaultMessage: 'Upcoming events',
                        description: 'Layout feed/Feed',
                    }),
                ],
                [
                    true,
                    intl.formatMessage({
                        defaultMessage: 'Past events',
                        description: 'Layout feed/Feed',
                    }),
                ],
            ])
    )
}

export function useCategoryOptions() {
    return useIntlMemo(
        intl =>
            new Map([
                [
                    undefined,
                    intl.formatMessage({
                        defaultMessage: 'All categories',
                        description: 'Layout feed/Feed',
                    }),
                ],
                [
                    'forecaster blog',
                    intl.formatMessage({
                        defaultMessage: 'Forecaster blog',
                        description: 'Layout feed/Feed',
                    }),
                ],
                [
                    'north-rockies',
                    intl.formatMessage({
                        defaultMessage: 'North Rockies',
                        description: 'Layout feed/Feed',
                    }),
                ],
                [
                    'south-rockies',
                    intl.formatMessage({
                        defaultMessage: 'South Rockies',
                        description: 'Layout feed/Feed',
                    }),
                ],
                [
                    'yukon',
                    intl.formatMessage({
                        defaultMessage: 'Yukon',
                        description: 'Layout feed/Feed',
                    }),
                ],
            ])
    )
}
